import { connect } from 'react-redux';

import { changeNicotineStrengthDetailsModalVisibility } from '../actions';
import NicotineStrengthDetailsModal from '../components/NicotineStrengthDetailsModal';

const mapStateToProps = state => {
  return {
    isOpen: state.nicotineStrengthDetailsIsOpen,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleModal: value => {
    dispatch(changeNicotineStrengthDetailsModalVisibility(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NicotineStrengthDetailsModal);
